import { render, staticRenderFns } from "./OLicensePlate.vue?vue&type=template&id=1ea53201&"
import script from "./OLicensePlate.vue?vue&type=script&lang=js&"
export * from "./OLicensePlate.vue?vue&type=script&lang=js&"
import style0 from "./OLicensePlate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports